import { getAllAdminDocuments, deleteAdminDocument, downloadAdminDocument, viewAdminDocument } from '../api/admin_document_api';
import GenericDocument from './GenericDocument';

const AdminDocument = ({ refreshTrigger }) => (
    <GenericDocument 
        title="מסמכי מערכת כלליים"
        fetchData={getAllAdminDocuments}
        deleteFunc={deleteAdminDocument}
        viewFunc={viewAdminDocument}
        downloadFunc={downloadAdminDocument}
        refreshTrigger={refreshTrigger}
    />
);

export default AdminDocument;